<template>

    <LayoutDefault>

        <section v-if="tpvBackLoading" class="fuid-resu__loading">

            <b-row>

                <b-col cols="12" class="fuid-form-to-render">

                    <h4 class="fuid-resu-tit text-center">{{ $t('paymentok.titloading') }}</h4>

                    <p class="text-center pt-3">{{ $t('resume.stit0') }}</p>

                    <div class="text-center p-3">

                        <b-spinner label="Loading..."></b-spinner>

                    </div>

                </b-col>
            
            </b-row>

        </section>

        <section v-else class="fuid-resu__loading">

            <section v-if="Ds_MerchantParameters" class="fuid-resu__tpvcontainer">

                <b-row>

                    <b-col cols="12" class="fuid-form-to-render">

                        <h4 v-if="renderError" class="fuid-resu-tit">{{ $t('paymentok.titseatsfull') }}</h4>
                        <h4 v-else class="fuid-resu-tit">{{ $t('paymentok.tit') }}</h4>

                    </b-col>

                </b-row>

                <b-row>

                    <b-col cols="12" class="fuid-resu__tpvok">

                        <p>{{ $t('paymentok.order') }}: {{ Ds_MerchantParameters.Ds_Order }}</p>
                        <p>{{ $t('paymentok.amount') }}: {{ amount }} {{ $t('payment.euro') }}</p>

                    </b-col>

                    <b-col v-if="renderError">

                        <div class="fuid-resu__tpvseats">

                            <h5>{{ $t('paymentok.seatsfull') }}</h5>

                            <div v-for="(id,index) in alumnosError" :key="index">

                                <span>{{ getAlumnoNombreById ( id ) }}</span>

                                <div v-for="(group,indexg) in ko[id]" :key="indexg">

                                    <strong>{{ getGroupLevelIdioma(group) }}</strong>

                                </div>

                            </div>

                        </div>

                    </b-col>

                    <b-col cols="12" class="d-flex justify-content-center align-items-center fuid-form__actions">

                        <button class="fuid-button fuid-button-step align-items-center" @click.prevent="toLogin()">

                            {{ $t("login.out") }}

                        </button>

                    </b-col>
                
                </b-row>

            </section>

            <section v-else>

                <b-row>

                    <b-col cols="12" class="fuid-form-to-render">

                        <h4 class="fuid-resu-tit">{{ $t('paymentko.tit') }}</h4>

                        <p>{{ $t('paymentko.tit') }}</p>

                    </b-col>

                </b-row>

            </section>

        </section>

    </LayoutDefault>

</template>

<script>

    import { mapGetters } from 'vuex'
    import { mapActions } from 'vuex'
    import errorFromServer from '@/components/errorFromServer'
    import LayoutDefault from '@/components/layouts/LayoutDefault'

    export default {

        data() {
            
            return {
                id: 10,
                tpvBackLoading: true,
                groups: false,
                prematricula: false,
                renderError: false,
                alumnosError: [],
                ko: null,
                matriculaFinish: {},
                Ds_MerchantParameters: null
            }

        },

        methods: {
            
            ...mapActions('Login', ['loginUser']),
            ...mapActions('Matricula', ['tpvBackPostData']),
            ...mapActions('Groups', ['getGroupsByCourse']),
            ...mapActions('Prematriculas', ['getCurso']),
            ...mapActions('Prematriculas', ['getPrematriculaByPersona']),

            getGroupLevelIdioma( id ) {

                let gr = this.getGroupsById(id)

                let groupData = gr[0]

                let groupRender = `${groupData.nivel.idioma.nombre} - ${groupData.nivel.descripcion} - ${groupData.dia.descripcion} - ${groupData.horario.descripcion}`

                return groupRender

            },

            getAlumnoNombreById( id ) {

                let nid = parseInt( id )

                return this.getAlumnoName( nid )

            },

            /*
            * Router to login
            *
            */
           toLogin() {

               localStorage.removeItem('logged')
               this.$router.push(`/${this.$i18n.locale}`)

           }

        },

        computed: {

            ...mapGetters('Groups', ['getGroupsById']),
            ...mapGetters('Prematriculas', ['getAlumnoName']),
            ...mapGetters('Prematriculas', ['getCursoActual']),
            
            amount: function() {
                
                let price = this.Ds_MerchantParameters.Ds_Amount
                let amount_main = price.substring(0, price.length - 2)
                let amount_dec = price.substring(price.length - 2, price.length)

                return `${amount_main}.${amount_dec}`

            }

        },

        components: {

            LayoutDefault,
            //errorFromServer

        },

        async mounted() {

            this.$nextTick(async() => {

                if(this.$route.query.Ds_MerchantParameters) {

                    // Decode from the GET that is in Base64 
                    let merchant_base64 = this.$CryptoJS.enc.Base64.parse( this.$route.query.Ds_MerchantParameters )

                    // Convert the string in a object
                    this.Ds_MerchantParameters = JSON.parse( this.$CryptoJS.enc.Utf8.stringify( merchant_base64 ) )
                    
                    // console.log( this.Ds_MerchantParameters )

                    // Send the data to the API bum bum
                    let logToken = await this.loginUser( { username: process.env.VUE_APP_API_USER, password: process.env.VUE_APP_API_PASSWORD, componentId: this.id } )

                    if( logToken ) {

                        let code = parseInt( this.Ds_MerchantParameters.Ds_Response )

                        this.matriculaFinish = await this.tpvBackPostData( { numeroPedido:this.Ds_MerchantParameters.Ds_Order, code:code, componentId: this.id } )
                        
                        // console.log( 'matriculaFinish' )
                        // console.log( this.matriculaFinish )

                        if( this.matriculaFinish.ko ) {

                            if ( Object.keys(this.matriculaFinish.ko).length > 0 ) { // Some group is full

                                this.curso = await this.getCurso({ componentId: this.id })

                                this.groups = await this.getGroupsByCourse( { idCurso: this.getCursoActual.id, page: 1, componentId: this.id } )

                                this.prematricula = await this.getPrematriculaByPersona( { personaId: this.matriculaFinish.solicitante, curso: this.getCursoActual.id, componentId: this.id } )

                                if( this.groups && this.prematricula ) {

                                    let kokeys = Object.keys(this.matriculaFinish.ko)

                                    kokeys.forEach((key, index) => {

                                        this.alumnosError.push(key)

                                    })

                                    // console.log(this.alumnosError)

                                    this.ko = this.matriculaFinish.ko
                                    this.renderError = true

                                }

                            }

                        }

                        this.tpvBackLoading = false

                        localStorage.removeItem('logged')

                    }

                } else {

                    this.tpvBackLoading = false

                    localStorage.removeItem('logged')

                }

            })

        }
        
    }
    
</script>